var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGiftBox = function SvgGiftBox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.5 3.25a1.75 1.75 0 1 0 0 3.5h3.51a9 9 0 0 0-.605-1.389C9.762 4.191 8.833 3.25 7.5 3.25M4.25 5c0 .625.18 1.231.511 1.75H2a.75.75 0 0 0-.75.75v5c0 .414.336.75.75.75h1.25v9.25c0 .414.336.75.75.75h16a.75.75 0 0 0 .75-.75v-9.25H22a.75.75 0 0 0 .75-.75v-5a.75.75 0 0 0-.75-.75h-2.761a3.25 3.25 0 0 0-2.739-5c-2.167 0-3.488 1.559-4.22 2.889a9 9 0 0 0-.28.553 9 9 0 0 0-.28-.553C10.988 3.309 9.667 1.75 7.5 1.75A3.25 3.25 0 0 0 4.25 5m8.74 1.75h3.51a1.75 1.75 0 0 0 0-3.5c-1.333 0-2.262.941-2.905 2.111a9 9 0 0 0-.605 1.389m-.24 1.5v3.5h8.5v-3.5h-8.5m-5.25 0h3.75v3.5h-8.5v-3.5zm5.25 13.5h6.5v-8.5h-6.5zm-1.5-8.5v8.5h-6.5v-8.5z",
    clipRule: "evenodd"
  })));
};
export default SvgGiftBox;